<app-side-modal
  #sideModal
  (goBack)="handleModalGoBack()"
  [hideReturnButton]="!isEditingAlert && !isAddingAlert"
>
  <button
    *ngIf="!isEditingAlert && !isAddingAlert"
    slot="right-corner"
    class="button-fab button-fab--small button-fab--clear"
    (click)="handleModalGoBack()"
  >
    <div class="button-fab button-fab--small"></div>
  </button>

  <button
    *ngIf="isEditingAlert"
    slot="right-corner"
    class="price-alerts__delete-button"
    (click)="handleDeleteAlertClick(alert.id, alert.issue_id)"
  >
    Eliminar
  </button>

  <div class="price-alerts" *ngIf="alertsByIssue">
    <ng-container *ngIf="!isEditingAlert && !isAddingAlert">
      <h1 class="price-alerts__title" *ngIf="alertsByIssue.length !== 0">
        Alertas de precio
      </h1>

      <div *ngIf="alertsByIssue.length === 0" class="price-alerts__list--empty">
        <div class="price-alerts__icon">
          <img src="images/icons/atm-bell.svg" />
        </div>
        <p class="price-alerts__empty-title">
          No te pierdas ninguna oportunidad del mercado
        </p>

        <p class="price-alerts__cta">
          Crea alertas de precio para acciones, ETFs y fondos
        </p>
      </div>

      <button
        type="button"
        class="button-fab button-fab--add button-fab--expandable-right button-fab--expandable"
        (click)="handleNewAlertClick()"
        aria-label="Crear"
      >
        <span>Crear</span>
      </button>

      <ul class="price-alerts__list">
        <li
          class="price-alerts__list-item"
          *ngFor="let issueAlerts of alertsByIssue"
        >
          <div class="price-alerts__item-title">
            {{ issueAlerts.key }}
          </div>
          <div
            class="price-alerts__item-data"
            (click)="handleAlertClick(priceAlert)"
            *ngFor="let priceAlert of issueAlerts.value"
          >
            <div>
              <div class="price-alerts__trigger-rule">
                {{
                  priceAlert.operator === 'greater'
                    ? 'Precio igual o mayor a'
                    : priceAlert.operator === 'less'
                    ? 'Precio igual o menor a'
                    : 'El precio suba o baje'
                }}
              </div>
              <div class="price-alerts__trigger-price">
                {{
                  priceAlert.type === 'percentage'
                    ? (priceAlert.limit_percentage / 100
                      | hbCustomFormat: '0,0.00%')
                    : (priceAlert.limit_price
                      | hbCustomFormat
                        : (priceAlert.limit_price < 1
                            ? '$0,0.00[0]'
                            : '$0,0.00'))
                }}
              </div>
            </div>
            <div class="price-alerts__item-toggler">
              <div class="checkbox-toggle" (click)="$event.stopPropagation()">
                <input
                  type="checkbox"
                  class="checkbox__input"
                  [name]="priceAlert.id + '-is-active'"
                  [checked]="priceAlert.is_active"
                />
                <label
                  class="checkbox__label"
                  [for]="priceAlert.id + '-is-active'"
                  (click)="handleToggleAlertClick(priceAlert)"
                ></label>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>

    <ng-container *ngIf="isAddingAlert || isEditingAlert">
      <h1 class="price-alerts__title" *ngIf="isAddingAlert">
        Crear alerta de precio
      </h1>
      <div class="form__item" *ngIf="isAddingAlert">
        <div class="input input--fluid">
          <label class="input__label"> Busca acciones, ETFs y fondos</label>
          <hb-search-box
            [useEventEmitterInsteadOfStore]="true"
            (selectedRowChange)="handleSearchBoxIssueSelection($event)"
          ></hb-search-box>
        </div>
      </div>

      <div *ngIf="isEditingAlert" class="price-alerts__issue">
        <div>
          <h2 class="price-alerts__issue-symbol">
            {{ issueData.issueID }}
          </h2>
          <h3 class="price-alerts__issue-name">
            {{ issueData.issueName }}
          </h3>
        </div>

        <div class="price-alerts__issue-price-container">
          <div class="price-alerts__price-integer">
            {{ issueData.lastPrice | hbCustomFormat: '$0,0' }}
            <span class="price-alerts__price-cents">
              {{
                issueData.lastPrice
                  | hbCustomFormat: (issueData.lastPrice < 1 ? '.00[0]' : '.00')
              }}
            </span>
          </div>

          <div
            class="price-alerts__issue-variation"
            [ngClass]="{
              'price-alerts__issue-variation--positive':
                issueData.variationPercentage > 0,
              'price-alerts__issue-variation--negative':
                issueData.variationPercentage < 0
            }"
          >
            {{
              issueData.lastPrice - issueData.openPrice
                | hbCustomFormat
                  : (issueData.lastPrice < 1 ? '$0,0.00[0]' : '$0,0.00')
            }}
            ({{
              issueData.variationPercentage / 100 | hbCustomFormat: '0.00%'
            }})
          </div>
        </div>
      </div>

      <div class="form__item">
        <div class="input input--fluid">
          <label class="input__label"> Quiero recibir una alerta cuando </label>
          <combo-select
            title="Quiero recibir una alerta cuando"
            [resultsList]="alertTriggers"
            [sentSelected]="selectedAlertTrigger"
            (emitSelectedItem)="handleAlertTypeChange($event.id)"
          >
          </combo-select>
        </div>
      </div>
      <div class="form__item">
        <div
          class="input input--fluid"
          [ngClass]="{ 'input--error': priceValidationErrors?.isError }"
        >
          <label class="input__label">{{
            triggerUnits === 'price' ? 'Precio' : 'Porcentaje'
          }}</label>
          <hb-input-money
            *ngIf="triggerUnits === 'price'"
            prefix="$"
            placeholder="$0.00"
            [value]="alert.limit_price || 0"
            (valueChange)="handleLimitPriceChange($event)"
            [addSteppers]="true"
          ></hb-input-money>
          <hb-input-money
            *ngIf="triggerUnits !== 'price'"
            suffix="%"
            placeholder="1%"
            [value]="alert.limit_percentage || 0"
            (valueChange)="handleLimitPercentageChange($event)"
            [addSteppers]="true"
            [restrictToIntegers]
          ></hb-input-money>
          <span
            [hidden]="!priceValidationErrors?.isError"
            class="input__message"
          >
            Ya tienes una alerta por este precio
            {{
              priceValidationErrors?.isSameContract ? '' : 'en otra estrategia'
            }}
          </span>
        </div>
      </div>

      <div class="form__item form__slot" *ngIf="triggerUnits === 'percentage'">
        Alerta recurrente
        <div class="checkbox-toggle form__checkbox">
          <input
            type="checkbox"
            class="checkbox__input"
            name="recurring-alert"
            [checked]="alert.is_recurrent"
          />
          <label
            class="checkbox__label"
            for="recurring-alert"
            (click)="alert.is_recurrent = !alert.is_recurrent"
          ></label>
        </div>
      </div>

      <div class="form__item form__slot form__slot--info">
        <img src="images/icons/atm-icn-bell.svg" />
        Recibirás la alerta de precio en tu correo electrónico
      </div>

      <div class="form__item--action">
        <button
          class="button button--small button--dark"
          (click)="
            isEditingAlert ? handleUpdateAlertClick() : handleCreateAlertClick()
          "
          [ngClass]="{ 'button--disabled': priceValidationErrors?.isError }"
        >
          {{ isEditingAlert ? 'Guardar cambios' : 'Crear alerta' }}
        </button>
      </div>
    </ng-container>
  </div>
</app-side-modal>

<app-full-modal
  *ngIf="isConfirmationModalOpen"
  [title]="
    isDeletingAlert
      ? '¿Deseas eliminar la alerta de precio?'
      : '¿Deseas actualizar la alerta de precio?'
  "
  [confirmationButtonText]="isDeletingAlert ? 'Sí, eliminar' : 'Sí, actualizar'"
  [description]="
    isDeletingAlert
      ? null
      : 'Ya tienes una alerta configurada con este porcentaje. Si la actualizas, se activará con base en el último precio.'
  "
  (onConfirmationAction)="confirmationModalHandler()"
  (onCloseModal)="isConfirmationModalOpen = false"
>
</app-full-modal>
